import { Const } from '../lib/const.cls'

export const mutations = {
	[Const.RESET_DIGIO_DATA] (state, data) {	
		try {
			state.digio_error = '';
			state.digio_data = null;
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_DIGIO_ERROR] (state, data) {	
		try {
			state.digio_error = data.error
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_DIGIO_RESPONSE] (state, data) {	
		try {
			state.digio_data = data.data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	//=========================== ========================tax-report=============================================================
	[Const.SET_KSOFT_TAX_REPORT_LIST] (state, data) {									
		try {
			state.ksoft_tax_report_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_TAX_REPORT_LIST] (state, data) {									
		try {
			state.tax_report_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_TAX_REPORT_LIST1] (state, data) {									
		try {
			state.tax_report = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_FINANCIAL_LEDGER_LIST1] (state, data) {									
		try {
			state.financial_ledger_list1 = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},


	[Const.SET_KSOFT_PROFILE_API] (state, data) {									
		try {
			state.ksoftProfileData = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_BANK_INFORMATION_IN_DETAIL] (state, data) {									
		try {
			state.bankInformationInDetail = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},


	[Const.SET_MARGIN_PLEDGE_SUCCESS_ISIN] (state, data) {									
		try {
			state.marginPledgeSuccessIsin = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},


	//---------------------------------------------------listing-----------------------------------------------------------------
	[Const.SET_PLEDGE_APPROVED_ISINS] (state, data) {									// profile page
		try {
			state.pledge_approved_isin = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_MF_CHART_DATA] (state, data) {									// profile page
		try {
			state.mf_chart_data = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_CATEGORIZATION_DATA_THROUGH_TICKET] (state, data) {									// profile page
		try {
			state.categorization_data_through_ticket = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_NOMINEE_ADD] (state, data) {									// profile page
		try {
			state.nomineeAddJson = data
			//console.log('setter',nomineeAddJson)
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_PROFILE_LIST] (state, data) {									// profile page
		try {
			state.profile_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_MARGIN_LIST] (state, data) {										// dashboard page
		try {
			state.margin_info_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_FINANCIAL_LEDGER_LIST] (state, data) {							// financial ledger page
		try {
			state.financial_ledger_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_REASON_TICKET]: (state, data) => {											// reason wise open ticket
		try {
			state.reason_open_ticket = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},	
	[Const.SET_CURRENT_LEVERAGE] (state, data) {							// financial ledger page
		try {
			state.current_leverage = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	
    [Const.SET_POSITION_HOLDING_ORDER_LIST] (state, data) {						// position or dashboard page
		try {
			state.position_holding_order_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_POSITION_KSOFT_HOLDING_ORDER_LIST] (state, data) {						// position or dashboard page
		try {
			state.position_ksoft_holding_order_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},


	[Const.SET_CLOSE_POSITION_LIST] (state, data) {								// position page
		try {
			state.close_position_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_TRADE_CONFIRMATION_LIST] (state, data) {							// trade confirm page
		try {
			state.trade_confirmation_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_CONTRACT_NOTE_LIST] (state, data) {								// contract note page
		try {
			state.contract_note_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_DEPOSIT_LIST] (state, data) {									// deposit page
		try {
			state.deposit_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUPPORT_LIST] (state, data) {									// support page
		try {
			state.support_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_PCR_DATA] (state, data) {									// support page
		try {
			state.pcr_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_CATEGORIZATION_DATA] (state, data) {									// support page
		try {
			state.categorization_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	
	//----------------------------------------------------view--------------------------------------------------------------------
	[Const.SET_SUPPORT_VIEW] (state, data) {									//support view page
		try {
			state.support_view = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_COMPLAINT_OTP_VIEW_DATA] (state, data) {							// otp send
		try {
			state.complaint_otp_view_data = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	//--------------------------------------------------dropdown------------------------------------------------------------------
	[Const.SET_SUPPORT_REASON_LIST] (state, data) {
		try {
			state.support_reason_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_PLATFORM_LIST] (state, data) {
		try {
			state.platform_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_XML_DOC_URL] (state, data) {
		try {
			state.xml_doc_url = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_SCRATCH_COUPON] (state, data) {
		try {
			state.scratch_coupon = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},


	[Const.SET_PORTFOLIO_LIST_DATA] (state, data) {
		try {
			state.portfolio_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_DASHBOARDSTATS] (state, data) {
		try {
			state.dashbaord_stats_ms = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_PORTFOLIO_LIST_DATA_AMOUNT] (state, data) {
		try {
			state.portfolio_list_amount = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_CATALOG_PRODUCT_LIST] (state, data) {									
		try {
			state.catalog_product_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	
	[Const.SET_CHECK_BALANCE] (state, data) {									
		try {
			state.check_balance = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_ORDER_HISTORY_LIST] (state, data) {									
		try {
			state.order_history = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	//==============referral coupon =============

	[Const.SET_COUPONS_LIST] (state, data) {									
		try {
			state.CouponsList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_BALANCE_AMOUNT] (state, data) {									
		try {
			state.balance = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},  

	[Const.SET_COUPON_ORDER_HISTORY_LIST] (state, data) {									
		try {
			state.CouponOrderList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},  


	[Const.SET_COUPON_CART_LIST] (state, data) {									
		try {
			state.Cartlist = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_PENDING_BALANCE] (state, data) {									
		try {
			state.pendingBalance = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	//=========nominee data=================
	[Const.SET_CLIENT_NOMINEE_DATA] (state, data) {									
		try {
			state.nomineeList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
}



// WEBPACK FOOTER //
// ./src/plugins/prism/provider/candle-history/store-addons/mutations.js